import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import Util from "@/Master/Util";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {comRequest, comTag} from "@/Fwk/Http/comRequest";
import {API} from "@/app/_api/types/auth";
import RequestMgr, {NetType} from "@/Fwk/Http/RequestMgr";
import RouterMgr from "@/Core/RouterMgr";
import UserMgr from "@/Core/UserMgr";
import {LoginUserType, UserGlobalInfo} from "@/Core/Login/types/user";
import GuideMgr, {GuideIDType} from "@/Core/GuideMgr";

export default class LoginNetManager {
    public static Instance = new LoginNetManager();
    private _loginToken: string = "";
    private _loginId: number = 0;
    // private _account: string = "";
    private _errorResponseCode: number = 0;
    private _zipCode: string = "";
    private _extInfo: LoginNetBackLoginExt | null = null;
    private _mobile: string = "";
    private isRequesting: boolean = false;
    private static onSecondTickInterval:any = null;
    private static secondTokenTime:number = 0;//token刷新时间
    private static tokenTimeMax:number = 30;//60S

    public get getLoginToken():string{
        return this._loginToken;
    }

    public get getLoginUserId():string{
        return this._loginId+'';
    }

    public get isLogin(): boolean {
        return !!(this._loginToken && this._loginId);
    }

    // 是否成功注册或者登陆
    // public get isSignUpOK(): boolean {
    //     return !!this._mobile;
    // }

    // 检查是否注册。没有注册自动跳转到登陆页面
    public get isSignUpOKToLogin(): boolean {
        const signUpOK = UserMgr.isSignUpOK;
        if (!signUpOK){
            RouterMgr.push("/login");
        }
        return signUpOK;
    }

    public get isBrushUser(): boolean {
        // 原逻辑中根据extInfo判断
        if (this._extInfo && this._extInfo.sm_tag && this._extInfo.sm_tag.indexOf("sm_withdrawal_farming") >= 0) {
            return true;
        }
        return false;
    }

    // 发送注册请求
    public async SendRegisterAccount(data: LoginNetSendRegister, onFinish: (res: HttpResponse<API.PostUserResponse>) => void){
        if (this.isRequesting) return false;
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.Register),
            method: 'POST',
            body: data,
        };
        const response = await this.DoSendRequest<API.PostUserResponse>(config);
        let responseData = response.data;
        if (response.code == 200 && responseData){
            this._mobile = responseData.mobile || '';
            this._loginId = responseData.id;
            // this._loginToken = responseData.token;
            LoginUIManager.setLastUserPassword(data.password);
            LoginUIManager.setLastUserAccount(data.mobile);
            LoginUIManager.setLastUserAreaCode(data.areaCode);
            LoginUIManager.setLastUserZipCode(data.zipCode);
            LoginUIManager.setLastUserId(responseData.id);
            LoginUIManager.setLastUserInfo(responseData.baseInfo);

            let updateData: Partial<UserGlobalInfo> = {
                baseInfo: responseData.baseInfo,
                // token: responseData.token,
                userId: responseData.id,
                zipCode: data.zipCode,
            }
            // if (responseData.token){
            //     updateData.token = responseData.token;
            // }
            UserMgr.updateUser('SignUp-Register',updateData);
            if (!GuideMgr.isGuideEnd){
                GuideMgr.setGuideId(GuideIDType.guide_1001)
            }
        }
        onFinish(response);
        return true;
    }

    // 登录请求
    public async SendLogin(data: LoginNetSendLogin, onFinish: (res: API.UserLoginResponse) => void, token = ''): Promise<boolean> {
        if (this.isRequesting) return false;
        data.forceQuit = '1';//统一强制登陆
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.Login),
            method: 'POST',
            body: data,
        };
        if (token){
            config.headers = {Authorization: token};
        }
        const response = await this.DoSendRequest<API.UserLoginResponse>(config);
        const responseData = response.data;
        this._mobile = data.mobile;
        this._loginToken = "";
        this._loginId = 0;
        this._zipCode = "";
        this._extInfo = null;
        if (responseData && response.code == 200){
            this._loginToken = responseData.token || "";
            this._loginId = responseData.id || 0;
            this._zipCode = responseData.zipCode || "";
            this._extInfo = responseData.extJson as LoginNetBackLoginExt || null;
            this._mobile = data.mobile || "";
            LoginUIManager.setLastUserToken(responseData.token);
            LoginUIManager.setLastUserId(responseData.id);
            LoginUIManager.setLastUserAreaCode(data.areaCode);
            LoginUIManager.setLastUserZipCode(responseData.zipCode);
            LoginUIManager.setLastUserInfo(responseData.baseInfo);
            LoginUIManager.setLastUserTokenTime(responseData.expireTime);
            LoginUIManager.setLastUserLoginType(LoginUserType.normal);
            LoginUIManager.setLastUserNickName(responseData.nickname);
            UserMgr.updateUser('SendLogin',{
                baseInfo:responseData.baseInfo,
                token:responseData.token,
                userId:responseData.id,
                zipCode:responseData.zipCode,
                expireTime:responseData.expireTime,
                loginType:LoginUserType.normal,
            });
            if (!GuideMgr.isGuideEnd){
                GuideMgr.setGuideId(GuideIDType.guide_1001);
            }
            this.OnLoginSuccessful({
                forceQuit: data.forceQuit !== "0"
            });
        }else{
            //todo 是否强制退出登陆
            // if (responseData.isForceLogin) {
            //     this.ClearSaveData(data);
            // }
            RouterMgr.push("/login");
        }
        onFinish(responseData);
        return true;
    }

    // 游客登录请求
    public async SendVistorLogin(onFinish: (res: API.VisitorLoginResponse) => void): Promise<boolean> {
        if (this.isRequesting) return false;
        const sendData: LoginNetSendVistorLogin = {} as LoginNetSendVistorLogin;
        sendData.gaid = Util.h5UUID;
        const lastUserId = LoginUIManager.getLastUserId;
        if (lastUserId){
            sendData.userId = lastUserId;
        }
        sendData.timeZone = Util.GetTimeZone;
        //todo 设置福利开关
        sendData.welfareSwitch = '1';

        this._loginToken = "";
        this._loginId = 0;
        this._zipCode = "";
        this._extInfo = null;

        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.visitorLogin),
            method: 'POST',
            body: sendData,
        };

        const response = await this.DoSendRequest<API.VisitorLoginResponse>(config);
        const responseData = response.data;
        if (response.code == 200 && responseData) {
            this._loginToken = responseData.token || "";
            this._loginId = responseData.id || 0;
            this._extInfo = responseData.extJson as LoginNetBackLoginExt || null;
            LoginUIManager.setLastUserToken(responseData.token);
            LoginUIManager.setLastUserId(responseData.id);
            LoginUIManager.setLastUserInfo(responseData.baseInfo);
            LoginUIManager.setLastUserTokenTime(responseData.expireTime);
            LoginUIManager.setLastUserLoginType(LoginUserType.visitor);
            UserMgr.updateUser('SendVistorLogin',{
                baseInfo:responseData.baseInfo,
                token:responseData.token,
                userId:responseData.id,
                loginType:LoginUserType.visitor,
                expireTime:responseData.expireTime,
            })
            this.OnLoginSuccessful({});
        }else{

        }
        onFinish(responseData);
        return true;
    }

    // 注销请求
    public async SendLogout(onFinish: (res: boolean) => void): Promise<boolean> {
        if (this.isRequesting || !this.isLogin) return false;

        this._loginToken = "";
        this._loginId = 0;
        this._zipCode = "";
        this._extInfo = null;

        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.Logout),
            method: 'POST',
            body: {},
        };

        const response = await this.DoSendRequest<API.UserLogoutResponse>(config);
        if (response.data) {
            this._loginToken = "";
            this._loginId = 0;
            this._zipCode = "";
            this._extInfo = null;
            UserMgr.resetUpdateUser();
            LoginUIManager.ClearAll();
            onFinish(true);
        }else{
            onFinish(false);
        }

        return true;
    }

    // 获取邮箱验证码
    public async SendResetPwd(data:LoginNetSendResetPwd,onFinish: (res:API.ResetPasswordResponse) => void): Promise<boolean> {
        if (this.isRequesting) return false;
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.ResetPwd),
            method: 'POST',
            body: {},
        };
        const response = await this.DoSendRequest<API.ResetPasswordResponse>(config);
        const responseData = response.data;
        if (responseData){
            LoginUIManager.setLastUserPassword(data.newPassword);
            onFinish(responseData);
        }else{
            onFinish(responseData);
        }
        return true;
    }

    // 刷新Token
    public async SendRefreshToken(onFinish: (res:LoginNetBackRefreshToken) => void): Promise<boolean> {
        if (this.isRequesting) return false;
        // if (this.isRequesting || !this.isLogin) return false;
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RefreshToken),
            method: 'POST',
            body: {},
            isBasic:true,
        };
        const response = await this.DoSendRequest<LoginNetBackRefreshToken>(config);
        const responseData = response.data;
        if (response.code == 200 && responseData){
            LoginUIManager.setLastUserTokenTime(responseData.expireTime);
            UserMgr.updateUser('SendRefreshToken',{
                expireTime:responseData.expireTime
            })
            onFinish(responseData);
        }else{
            onFinish(responseData);
        }
        return true;
    }

    // 发送手机验证码
    public async SendMobileVerifyCode(data: SendMobileVerifyCode, onFinish: (res: string) => void): Promise<boolean> {
        if (this.isRequesting) return false;
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.SendCode),
            method: 'POST',
            body: data,
        };
        const responseData = await this.DoSendRequest<string>(config);
        if (responseData.data){
            onFinish(responseData.data);
        }else{
            onFinish('123456');
        }
        return true;
    }

    // 更新用户基础信息。金钱相关的内容
    public async UpdateUserBaseInfo(onFinish?: (res: API.GetUserInfoResponse) => void): Promise<boolean> {
        if (this.isRequesting) return false;
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.GetUserInfo),
            method: 'POST',
            body: {},
        };
        const response = await this.DoSendRequest<API.GetUserInfoResponse>(config);
        const responseData = response.data;
        if (response.code == 200 && responseData) {
            LoginUIManager.setLastUserInfo(responseData);
            UserMgr.updateUser('User-UpdateBaseInfo',{
                baseInfo:responseData,
            })
        }
        if (onFinish) onFinish(responseData);
        return true;
    }

    public async DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
        this.isRequesting = true;
        config.isSerErrTips = true;
        const sendRequest = await comRequest<T>(config);
        this.isRequesting = false;
        return sendRequest;
    }

    // 发起KYC请求
    // public async SendReviewKYC(data: SendReviewKYC, onResponse: (res: LoginNetResponseData<ReviewKYCBack>) => void): Promise<void> {
    //     const enc = this.RequestDataToJson(data);
    //     const rawData = await this.DoSendRequest(LoginNetType.KYC, enc, false);
    //     const responseData = this.ByteToResponseData<ReviewKYCBack>(rawData);
    //     onResponse(responseData);
    // }

    private OnLoginSuccessful(responseData: SocketData) {
        if (Util.isLog) console.log(comTag, `刷新token 开始记录事件 每隔${LoginNetManager.tokenTimeMax}S去刷新接口，当前时间:${LoginNetManager.secondTokenTime}`);
        LoginNetManager.StartUpdateToken();
    }

    public static StartUpdateToken(forceRefresh:boolean = false){
        if (LoginNetManager.onSecondTickInterval) clearInterval(LoginNetManager.onSecondTickInterval);
        LoginNetManager.secondTokenTime = 0;
        if (forceRefresh){
            if (Util.isLog){
                console.log(comTag, "强制刷新token UpdateUserToken",LoginUIManager.getLastUserToken,LoginUIManager.getLastUserId);
            }
            this.UpdateUserToken(()=>{
                LoginNetManager.Instance.UpdateUserBaseInfo();
            });
        }
        LoginNetManager.CheckTime();
    }

    public static UpdateUserToken(action?:()=>void){
        if (Util.isLog){
            console.log(comTag, "刷新token UpdateUserToken",LoginUIManager.getLastUserToken,LoginUIManager.getLastUserId);
        }
        LoginNetManager.Instance.SendRefreshToken((res: any) => {
            if (Util.isLog) console.log(comTag, "刷新token成功",res);
            action && action();
        }).then(r =>{})
    }

     public static CheckTime(){
        if (this.onSecondTickInterval) return;

        if (Util.isLog) console.log(comTag, `刷新token 开始记录事件 每隔${this.tokenTimeMax}S去刷新接口，当前时间:${this.secondTokenTime}`);

        this.onSecondTickInterval = setInterval(() => {
            this.secondTokenTime++;
            if (Util.isLog) console.log(comTag, `刷新token 当前时间:${this.secondTokenTime} 刷新时间:${this.tokenTimeMax}`);
            if (this.secondTokenTime >= this.tokenTimeMax){
                this.secondTokenTime = 0 ;
                this.UpdateUserToken(()=>{
                    LoginNetManager.Instance.UpdateUserBaseInfo();
                });
            }
        }, 1000);
    }

}

// 导出实例
// export const LoginNetManager = LoginNetManager.Instance;
